import template from './summary-view.template.html';
import {SummaryViewController} from './summary-view.controller';

export const SummaryViewComponent = {
    templateUrl: template,
    controller: SummaryViewController
};



// WEBPACK FOOTER //
// ./src/js/views/summary-view/summary-view.component.js